import { render } from "./NavbarComp.vue?vue&type=template&id=b6078758"
import script from "./NavbarComp.vue?vue&type=script&lang=js"
export * from "./NavbarComp.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__